import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import clsx from 'clsx';
import { useAuthStore } from '../../stores/authStore';
import { CHEMINS } from '../../lib/navigation/chemins';
import { partieCourante, PARTIES } from '../../lib/navigation/espaces';

/**
 * La barre de l'administration : ses quatre parties, et rien d'autre
 * (décidé par Éclosion le 27/09/2026) — Tableau de bord, Comptabilité,
 * Planification, Gestion. Le détail de Comptabilité et de Planification est
 * dans leur menu latéral (`EspaceLayout`) ; Gestion est l'espace `/staff`.
 */
const AdminNavbar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { signOut } = useAuthStore();
  const courante = partieCourante(pathname);

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <nav className="relative z-50 bg-white shadow">
      <div className="mx-auto w-full max-w-screen-2xl px-4">
        <div className="flex min-h-16 flex-wrap items-center justify-between gap-2 py-2">
          <div className="flex flex-wrap items-center gap-1">
            <Link to={CHEMINS.tableauDeBord} className="mr-3 font-semibold text-gray-900">
              Éclosion
            </Link>
            {PARTIES.map((p) => (
              <Link
                key={p.chemin}
                to={p.chemin}
                title={p.libelle}
                aria-label={p.libelle}
                aria-current={courante?.chemin === p.chemin ? 'page' : undefined}
                className={clsx(
                  'flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium',
                  courante?.chemin === p.chemin
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-gray-700 hover:bg-gray-100',
                )}
              >
                <p.icone className="h-4 w-4" />
                <span className="hidden sm:inline">{p.libelle}</span>
              </Link>
            ))}
          </div>

          <button
            onClick={handleSignOut}
            className="flex items-center text-gray-700 hover:text-primary-600"
            aria-label="Se déconnecter"
            title="Se déconnecter"
          >
            <LogOut className="h-5 w-5" />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;
